import { extend } from 'sk-ui/lib/utils/util.js'

import feedbackReplyForm from './metaData/feedbackReplyForm'

export default {
  FeedbackReply({ commit }, params) {
    const props = {
      title: '回复问题或建议',
      params: {
        feedbackId: params.rowIds[0]
      }
    }
    const editForm = extend(true, {}, feedbackReplyForm)
    this.dispatch('OpenFullDialog', { metaData: editForm, props, clone: false })
  }
}
